function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/**
 * Purpose: SETFIELD opcode — copy a value into a writable context location.
 *
 * Language shape:
 *   script.reference  — destination path (must be context.*)
 *   script.value      — literal or resolve_ref source
 *
 * Read-only destinations (script.*, witness.*, tx.*, blk.*) are rejected.
 */

module.exports = {
  name: 'SETFIELD',
  description: "\nCopies a value into a writable location in the execution context.\n\nreference is the destination path. value is a literal or a normal RustScript\nreference resolved like every other opcode operand.\n\nOnly context.* destinations are writable.\n",
  exampleScript: {
    op: 'SETFIELD',
    reference: 'context.constitution.owner',
    value: '__opcodes.importfield.owner'
  },
  execute: function execute(node, context) {
    if (!node || _typeof(node) !== 'object' || !context || _typeof(context) !== 'object') {
      return false;
    }
    var reference = node.reference;
    if (typeof reference !== 'string' || reference.length === 0) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(node, 'value')) {
      return false;
    }
    if (!reference.startsWith('context.')) {
      return false;
    }
    var path = reference.slice('context.'.length);
    if (!path || isForbiddenWritePath(path)) {
      return false;
    }
    var value = resolveRef(context, node.value);
    return setContextPath(context, path, value);
  }
};
function isForbiddenWritePath(path) {
  return path === 'script' || path.startsWith('script.') || path === 'witness' || path.startsWith('witness.') || path === 'tx' || path.startsWith('tx.') || path === 'blk' || path.startsWith('blk.');
}
function pathSegments(path) {
  return String(path).replace(/\[/g, '.').replace(/\]/g, '').split('.').filter(function (s) {
    return s.length > 0;
  });
}
function setContextPath(root, path, value) {
  var segments = pathSegments(path);
  if (!segments.length) {
    return false;
  }
  var current = root;
  for (var i = 0; i < segments.length; i += 1) {
    var segment = segments[i];
    var isLast = i === segments.length - 1;
    var asIndex = /^[0-9]+$/.test(segment) ? Number(segment) : null;
    if (isLast) {
      if (asIndex !== null) {
        if (!Array.isArray(current) || asIndex >= current.length) {
          return false;
        }
        current[asIndex] = value;
        return true;
      }
      if (!current || _typeof(current) !== 'object' || Array.isArray(current)) {
        return false;
      }
      current[segment] = value;
      return true;
    }
    if (asIndex !== null) {
      if (!Array.isArray(current) || asIndex >= current.length) {
        return false;
      }
      current = current[asIndex];
      continue;
    }
    if (!current || _typeof(current) !== 'object' || Array.isArray(current)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(current, segment)) {
      current[segment] = {};
    }
    current = current[segment];
  }
  return false;
}
function resolveRef(root, ref) {
  if (typeof ref !== 'string') {
    return ref;
  }
  var parts = ref.split('.');
  var cursor = root;
  for (var i = 0; i < parts.length; i += 1) {
    var key = parts[i];
    if (!cursor || _typeof(cursor) !== 'object' || !Object.prototype.hasOwnProperty.call(cursor, key)) {
      return ref;
    }
    cursor = cursor[key];
  }
  return cursor;
}